export const translations = {
    he: {
        // App Navigation
        dashboard: 'דשבורד',
        users: 'דיירים',
        payments: 'תשלום וועד',
        managementCompany: 'חברת ניהול',
        messages: 'הודעות',
        sharedMessages: 'הודעות משותפות',
        expenses: 'הוצאות',
        tasks: 'משימות',
        events: 'אירועים',
        personalInfo: 'מידע אישי',
        notifications: 'התראות',
        openTicket: 'פתיחת קריאה',
        settings: 'הגדרות',
        
        // User Interface
        logout: 'התנתקות',
        profile: 'פרופיל',
        user: 'משתמש',
        buildingManager: 'מנהל',
        tenant: 'דייר',
        
        // Settings Page
        settingsTitle: 'הגדרות',
        settingsSubtitle: 'נהל את הגדרות המערכת שלך',
        notificationSettings: 'הגדרות התראות',
        systemSettings: 'הגדרות מערכת',
        systemNotifications: 'התראות במערכת',
        emailNotifications: 'התראות אימייל',
        smsNotifications: 'התראות SMS',
        darkMode: 'מצב כהה',
        language: 'שפה',
        autoBackup: 'גיבוי אוטומטי',
        saveSettings: 'שמור הגדרות',
        cancel: 'ביטול',
        
        // Languages
        hebrew: 'עברית',
        english: 'English',
        arabic: 'العربية',
        
        // Building Management
        selectBuilding: 'בחר בניין',
        loadingBuildings: 'טוען בניינים...',
        noBuildingsAvailable: 'אין בניינים זמינים',
        noPermissions: 'אין לך הרשאות ניהול או ועד לאף בניין. פנה למנהל המערכת.',
        
        // Subscription Status
        validUntil: 'בתוקף עד',
        daysRemaining: 'נותר {days} יום',
        trialExpired: 'תקופת הניסיון הסתיימה',
        
        // Dashboard
        totalResidents: 'סה״כ דיירים',
        thisMonthIncome: 'הכנסות החודש',
        thisMonthExpenses: 'הוצאות החודש',
        netProfit: 'יתרה',
        unpaidApartments: 'דירות לא שולמו',
        upcomingTasks: 'משימות קרובות',
        upcomingEvents: 'אירועים קרובים',
        recentExpenses: 'הוצאות אחרונות',
        quickActions: 'פעולות מהירות',
        reports: 'דוחות',
        sendReminders: 'שלח תזכורות',
        viewAll: 'צפה בהכל',
        noData: 'אין נתונים',
        
        // Table Headers
        apartmentNumber: 'מספר דירה',
        residentName: 'שם הדייר',
        amount: 'סכום',
        status: 'סטטוס',
        dueDate: 'תאריך יעד',
        description: 'תיאור',
        date: 'תאריך',
        category: 'קטגוריה',
        actions: 'פעולות',
        total: 'סה״כ',
        
        // Status Labels
        paid: 'שולם',
        unpaid: 'לא שולם',
        overdue: 'באיחור',
        completed: 'הושלם',
        pending: 'בהמתנה',
        inProgress: 'בעבודה',
        cancelled: 'בוטל',
        active: 'פעיל',
        inactive: 'לא פעיל',
        
        // Time/Date Labels
        today: 'היום',
        yesterday: 'אתמול',
        tomorrow: 'מחר',
        thisWeek: 'השבוע',
        thisMonth: 'החודש',
        lastMonth: 'החודש שעבר',
        nextMonth: 'החודש הבא',
        notAvailable: 'לא זמין',
        
        // Common
        save: 'שמור',
        close: 'סגור',
        loading: 'טוען...',
        error: 'שגיאה',
        success: 'הצלחה',
        edit: 'ערוך',
        delete: 'מחק',
        add: 'הוסף',
        search: 'חיפוש',
        filter: 'סינון',
        export: 'יצוא',
        import: 'יבוא',
        print: 'הדפס',
        time: 'שעה',
        location: 'מיקום',
        phone: 'טלפון',
        buildingCreationDate: 'תאריך הקמת בניין',
        unpaidMonths: 'חודשים לא שולמו',
        unpaidResidents: 'דיירים שלא שילמו',
        clickForDetails: 'לחץ לצפייה בפרטים',
        notAvailableShort: 'לא זמין',
        noEmailsAvailable: 'אין כתובות אימייל זמינות לדיירי הדירה',
        emailRemindersSent: 'תזכורות אימייל נשלחו בהצלחה',
        emailSendError: 'שגיאה בשליחת תזכורות אימייל',
        noPhoneNumbers: 'אין מספרי טלפון זמינים לשליחת WhatsApp',
        whatsappRemindersSent: 'תזכורות WhatsApp נשלחו בהצלחה',
        whatsappSendError: 'שגיאה בשליחת תזכורות WhatsApp',
        debtDetails: 'פירוט חובות - דירה',
        buildingInfo: 'מידע על הבניין',
        buildingCreationDateLabel: 'תאריך הקמת בניין',
        apartmentResidents: 'דיירי הדירה',
        residents: 'דיירים',
        unpaidMonthsDetails: 'חודשים שלא שולמו',
        outOfTotalMonths: 'מתוך',
        months: 'חודשים',
        
        // Table Headers - General
        fullName: 'שם מלא',
        email: 'דוא"ל',
        address: 'כתובת',
        city: 'עיר',
        floors: 'קומות',
        apartments: 'דירות',
        postalCode: 'מיקוד',
        creationDate: 'תאריך יצירה',
        joinDate: 'תאריך הצטרפות',
        floor: 'קומה',
        floorNumber: 'מספר קומה',
        relationshipType: 'סוג יחס',
        userPermissions: 'הרשאות משתמש',
        settings: 'הגדרות',
        notSpecified: 'לא צוין',
        
        // Events
        eventName: 'שם אירוע',
        eventLocation: 'מיקום',
        eventDetails: 'פרטי אירוע',
        dateAndTime: 'תאריך ושעה',
        confirmations: 'מאשרים',
        createdBy: 'נוצר על ידי',
        
        // Messages
        messageTitle: 'כותרת',
        messageContent: 'תוכן ההודעה',
        title: 'כותרת',
        content: 'תיאור',
        building: 'בניין',
        replies: 'תגובות',
        updateDate: 'תאריך עדכון',
        
        // Notifications
        notificationType: 'סוג',
        notificationDetails: 'פרטים',
        priority: 'עדיפות',
        
        // Payments
        year: 'שנה',
        monthsPaid: 'חודשים שולמו',
        paymentTypes: 'סוגי תשלום',
        totalAmount: 'סה״כ סכום',
        paymentMethod: 'אמצעי תשלום',
        receipts: 'קבלות',
        emailFiles: 'קבצי אימייל',
        transactionId: 'מזהה עסקה',
        
        // Expenses
        invoice: 'חשבונית',
        supplier: 'ספק',
        invoiceNumber: 'מספר חשבונית',
        paymentTo: 'תשלום ל',
        
        // Users Import
        missing: 'חסר',
        notSelected: 'לא נבחר',
        empty: 'ריק',
        todayDate: 'תאריך היום',
        defaultMaintenance: 'תחזוקה שוטפת (ברירת מחדל)',
        defaultOwner: 'בעלים (ברירת מחדל)',
        defaultCash: 'מזומן (ברירת מחדל)',
        
        // Suppliers
        supplierName: 'שם הספק',
        contactPerson: 'איש קשר',
        serviceTypes: 'סוגי שירות',
        
        // Management Company
        companyName: 'שם החברה',
        
        // Status Labels
        completed: 'הושלם',
        failed: 'נכשל',
        waiting: 'ממתין',
        returned: 'הוחזר',
        creditCard: 'כרטיס אשראי',
        bankTransfer: 'העברה בנקאית',
        cash: 'מזומן',
        
        // Pagination
        showing: 'מציג',
        of: 'מתוך',
        page: 'עמוד',
        resultsPerPage: 'תוצאות בעמוד',
        
        // Filter Options
        allStatuses: 'כל הסטטוסים',
        activity: 'פעילות',
        inactive: 'לא פעילות',
        waiting: 'ממתינים',
        approved: 'מאושרים',
        ended: 'הסתיימו',
        
        // Authentication
        loginSuccessMessage: 'החשבון שלך אומת בהצלחה! אנא התחבר למערכת.',
        loginFailedMessage: 'אימות נכשל. אנא נסה שוב.',
        emailRequired: 'נדרש להזין כתובת מייל',
        passwordRequired: 'נדרש להזין סיסמה',
        userNotAssociatedWithBuilding: 'המשתמש לא משויך לאף בניין',
        noPermissionsToAccess: 'אין לך הרשאות לגשת למערכת',
        trialExpiredAllBuildings: 'תקופת הניסיון עבור כל הבניינים הסתיימה',
        emailLabel: 'דואר אלקטרוני',
        passwordLabel: 'סיסמה',
        rememberMe: 'זכור אותי',
        loginButton: 'התחבר',
        registerNow: 'הירשם עכשיו',
        backToHomePage: 'חזרה לעמוד הראשי',
        
        // Registration
        fullNameLabel: 'שם מלא',
        phoneLabel: 'מספר טלפון',
        cityLabel: 'עיר',
        addressLabel: 'כתובת',
        apartmentNumberLabel: 'מספר דירה',
        floorNumberLabel: 'מספר קומה',
        confirmPasswordLabel: 'אישור סיסמה',
        enterCity: 'הזן עיר',
        enterStreet: 'הזן רחוב',
        addNewCity: 'הוסף עיר חדשה',
        addNewStreet: 'הוסף רחוב חדש',
        noResultsFound: 'לא נמצאו תוצאות',
        
        // Email Verification
        enterSixDigitCode: 'אנא הזן קוד בן 6 ספרות',
        verificationCompleted: 'האימות הושלם בהצלחה!',
        emailVerifiedSuccessfully: 'כתובת המייל אומתה בהצלחה!',
        emailVerificationForPasswordReset: 'אימות כתובת מייל לאיפוס סיסמה',
        verificationCode: 'קוד אימות',
        verify: 'אמת',
        resendCode: 'שלח קוד מחדש',
        verifying: 'מאמת...',
        
        // Forgot Password
        resetCodeSent: 'קוד איפוס נשלח לכתובת המייל שלך',
        emailNotVerified: 'כתובת המייל טרם אומתה',
        
        // Landing Page
        trialExpiredMessage: 'תקופת הניסיון הסתיימה',
        welcomeMessage: 'ברוכים הבאים',
        smartBuildingManagement: 'מערכת לניהול חכם של ועד בית',
        keyFeatures: 'הפיצ\'רים המרכזיים',
        
        // Building Management
        userNotLoggedIn: 'משתמש לא מחובר',
        fillAllFields: 'אנא מלא את כל השדות',
        invalidFloorsNumber: 'מספר קומות לא תקין',
        buildingAddedSuccessfully: 'הבניין נוסף בהצלחה!',
        addNewBuilding: 'הוסף בניין חדש',
        buildingDetails: 'פרטי הבניין',
        numberOfFloors: 'מספר קומות',
        numberOfApartments: 'מספר דירות',
        houseNumber: 'מספר בית',
        street: 'רחוב',
        
        // Navigation
        navigationMenu: 'תפריט ניווט',
        
        // Common Actions
        submit: 'שלח',
        sending: 'שולח...',
        update: 'עדכון',
        yes: 'כן',
        no: 'לא',
        tenant: 'שוכר',
        manager: 'מנהל',
        committeeMembe: 'חבר ועד',
        
        // Issues/Support
        openHelpTicket: 'פתיחת קריאת עזרה',
        subjectOfInquiry: 'נושא הפניה',
        submitInquiry: 'שלח פניה',
        
        // Announcements
        announcements: 'הודעות',
        addAnnouncement: 'הוסף הודעה',
        
        // Billing
        loadingBillingData: 'טוען נתוני חיוב...',
        buildingAccessBlocked: 'הגישה לבניין חסומה',
        billingAndSubscriptionsManagement: 'ניהול חיוב ומנויים',
        subscriptionStatus: 'סטטוס מנוי',
        paymentHistory: 'היסטוריית תשלומים',
        quickActions: 'פעולות מהירות',
        
        // Payment Methods
        creditCard: 'כרטיס אשראי',
        bankTransfer: 'העברה בנקאית',
        cash: 'מזומן',
        check: 'צ\'ק',
        noSubscriptionFound: 'לא נמצא מנוי עבור בניין זה',
        
        // Tasks
        task: 'משימה',
        building: 'בניין',
        description: 'תיאור',
        priority: 'עדיפות',
        currentStatus: 'סטטוס נוכחי',
        
        // Validation Messages
        fullNameRequired: 'שם מלא הוא שדה חובה',
        phoneRequired: 'מספר טלפון הוא שדה חובה',
        invalidEmail: 'כתובת דוא"ל לא תקינה',
        passwordMinLength: 'סיסמה חייבת להכיל לפחות 6 תווים',
        emailAlreadyExists: 'דוא"ל זה כבר קיים במערכת',
        
        // Cities (for fallback)
        telAviv: 'תל אביב',
        jerusalem: 'ירושלים',
        haifa: 'חיפה',
        beerSheba: 'באר שבע',
        rishonLezion: 'ראשון לציון',
        
        // Streets (for fallback)
        herzlStreet: 'הרצל',
        bialikStreet: 'ביאליק',
        weizmannStreet: 'ויצמן',
        allenbyStreet: 'אלנבי',
        benGurionStreet: 'בן גוריון',
        
        // Additional Login texts
        loginFailed: 'ההתחברות נכשלה. אנא בדוק את פרטיך ונסה שוב.',
        emailVerificationRequired: 'כדי להתחבר, עליך לאמת את כתובת המייל שלך.',
        systemLogin: 'התחברות למערכת',
        enterLoginDetails: 'אנא הזן את פרטי ההתחברות שלך',
        forgotPassword: 'שכחת סיסמה?',
        rememberMeSubtext: '(יישמר הנתונים גם לאחר סגירת הדפדפן)',
        loggingIn: 'מתחבר...',
        goToPayment: 'עבור לתשלום',
        registerNewAccount: 'הירשם עכשיו',
        backToMain: 'חזרה לעמוד הראשי',
        emailVerificationRequired2: 'נדרש אימות כתובת מייל',
        connectingToSystem: 'מתחבר למערכת...',
        trialExpiredMessageShort: 'תקופת הניסיון הסתיימה',
        choosePaymentPlan: 'יש לבחור תוכנית תשלום כדי להמשיך להשתמש במערכת',
        emailNotAvailable: 'כתובת המייל לא זמינה. אנא נסה להירשם שוב.',
        newVerificationCodeSent: 'קוד אימות חדש נשלח לכתובת המייל שלך. אנא בדוק את תיבת הדואר.',
        errorSendingVerificationCode: 'שגיאה בשליחת קוד האימות. אנא נסה שוב.'
    },
    en: {
        // App Navigation
        dashboard: 'Dashboard',
        users: 'Residents',
        payments: 'Committee Payment',
        managementCompany: 'Management Company',
        messages: 'Messages',
        sharedMessages: 'Shared Messages',
        expenses: 'Expenses',
        tasks: 'Tasks',
        events: 'Events',
        personalInfo: 'Personal Info',
        notifications: 'Notifications',
        openTicket: 'Open Ticket',
        settings: 'Settings',
        
        // User Interface
        logout: 'Logout',
        profile: 'Profile',
        user: 'User',
        buildingManager: 'Building Manager',
        tenant: 'Tenant',
        
        // Settings Page
        settingsTitle: 'Settings',
        settingsSubtitle: 'Manage your system settings',
        notificationSettings: 'Notification Settings',
        systemSettings: 'System Settings',
        systemNotifications: 'System Notifications',
        emailNotifications: 'Email Notifications',
        smsNotifications: 'SMS Notifications',
        darkMode: 'Dark Mode',
        language: 'Language',
        autoBackup: 'Auto Backup',
        saveSettings: 'Save Settings',
        cancel: 'Cancel',
        
        // Languages
        hebrew: 'עברית',
        english: 'English',
        arabic: 'العربية',
        
        // Building Management
        selectBuilding: 'Select Building',
        loadingBuildings: 'Loading buildings...',
        noBuildingsAvailable: 'No buildings available',
        noPermissions: 'You do not have management or committee permissions for any building. Contact the system administrator.',
        
        // Subscription Status
        validUntil: 'Valid until',
        daysRemaining: '{days} days remaining',
        trialExpired: 'Trial period expired',
        
        // Dashboard
        totalResidents: 'Total Residents',
        thisMonthIncome: 'This Month Income',
        thisMonthExpenses: 'This Month Expenses',
        netProfit: 'Net Profit',
        unpaidApartments: 'Unpaid Apartments',
        upcomingTasks: 'Upcoming Tasks',
        upcomingEvents: 'Upcoming Events',
        recentExpenses: 'Recent Expenses',
        quickActions: 'Quick Actions',
        reports: 'Reports',
        sendReminders: 'Send Reminders',
        viewAll: 'View All',
        noData: 'No Data',
        
        // Table Headers
        apartmentNumber: 'Apartment Number',
        residentName: 'Resident Name',
        amount: 'Amount',
        status: 'Status',
        dueDate: 'Due Date',
        description: 'Description',
        date: 'Date',
        category: 'Category',
        actions: 'Actions',
        total: 'Total',
        
        // Status Labels
        paid: 'Paid',
        unpaid: 'Unpaid',
        overdue: 'Overdue',
        completed: 'Completed',
        pending: 'Pending',
        inProgress: 'In Progress',
        cancelled: 'Cancelled',
        active: 'Active',
        inactive: 'Inactive',
        
        // Time/Date Labels
        today: 'Today',
        yesterday: 'Yesterday',
        tomorrow: 'Tomorrow',
        thisWeek: 'This Week',
        thisMonth: 'This Month',
        lastMonth: 'Last Month',
        nextMonth: 'Next Month',
        notAvailable: 'Not Available',
        
        // Common
        save: 'Save',
        close: 'Close',
        loading: 'Loading...',
        error: 'Error',
        success: 'Success',
        edit: 'Edit',
        delete: 'Delete',
        add: 'Add',
        search: 'Search',
        filter: 'Filter',
        export: 'Export',
        import: 'Import',
        print: 'Print',
        time: 'Time',
        location: 'Location',
        phone: 'Phone',
        buildingCreationDate: 'Building Creation Date',
        unpaidMonths: 'Unpaid Months',
        unpaidResidents: 'Unpaid Residents',
        clickForDetails: 'Click for Details',
        notAvailableShort: 'Not Available',
        noEmailsAvailable: 'No email addresses available for apartment residents',
        emailRemindersSent: 'Email reminders sent successfully',
        emailSendError: 'Error sending email reminders',
        noPhoneNumbers: 'No phone numbers available for WhatsApp sending',
        whatsappRemindersSent: 'WhatsApp reminders sent successfully',
        whatsappSendError: 'Error sending WhatsApp reminders',
        debtDetails: 'Debt Details - Apartment',
        buildingInfo: 'Building Information',
        buildingCreationDateLabel: 'Building Creation Date',
        apartmentResidents: 'Apartment Residents',
        residents: 'Residents',
        unpaidMonthsDetails: 'Unpaid Months',
        outOfTotalMonths: 'out of',
        months: 'months',
        
        // Table Headers - General
        fullName: 'Full Name',
        email: 'Email',
        address: 'Address',
        city: 'City',
        floors: 'Floors',
        apartments: 'Apartments',
        postalCode: 'Postal Code',
        creationDate: 'Creation Date',
        joinDate: 'Join Date',
        floor: 'Floor',
        floorNumber: 'Floor Number',
        relationshipType: 'Relationship Type',
        userPermissions: 'User Permissions',
        settings: 'Settings',
        notSpecified: 'Not Specified',
        
        // Events
        eventName: 'Event Name',
        eventLocation: 'Location',
        eventDetails: 'Event Details',
        dateAndTime: 'Date and Time',
        confirmations: 'Confirmations',
        createdBy: 'Created By',
        
        // Messages
        messageTitle: 'Title',
        messageContent: 'Message Content',
        title: 'Title',
        content: 'Description',
        building: 'Building',
        replies: 'Replies',
        updateDate: 'Update Date',
        
        // Notifications
        notificationType: 'Type',
        notificationDetails: 'Details',
        priority: 'Priority',
        
        // Payments
        year: 'Year',
        monthsPaid: 'Months Paid',
        paymentTypes: 'Payment Types',
        totalAmount: 'Total Amount',
        paymentMethod: 'Payment Method',
        receipts: 'Receipts',
        emailFiles: 'Email Files',
        transactionId: 'Transaction ID',
        
        // Expenses
        invoice: 'Invoice',
        supplier: 'Supplier',
        invoiceNumber: 'Invoice Number',
        paymentTo: 'Payment To',
        
        // Users Import
        missing: 'Missing',
        notSelected: 'Not Selected',
        empty: 'Empty',
        todayDate: 'Today Date',
        defaultMaintenance: 'Regular Maintenance (Default)',
        defaultOwner: 'Owner (Default)',
        defaultCash: 'Cash (Default)',
        
        // Suppliers
        supplierName: 'Supplier Name',
        contactPerson: 'Contact Person',
        serviceTypes: 'Service Types',
        
        // Management Company
        companyName: 'Company Name',
        
        // Status Labels
        completed: 'Completed',
        failed: 'Failed',
        waiting: 'Waiting',
        returned: 'Returned',
        creditCard: 'Credit Card',
        bankTransfer: 'Bank Transfer',
        cash: 'Cash',
        
        // Pagination
        showing: 'Showing',
        of: 'of',
        page: 'Page',
        resultsPerPage: 'Results per page',
        
        // Filter Options
        allStatuses: 'All Statuses',
        activity: 'Active',
        inactive: 'Inactive',
        waiting: 'Waiting',
        approved: 'Approved',
        ended: 'Ended',
        
        // Authentication
        loginSuccessMessage: 'Your account has been successfully verified! Please log in to the system.',
        loginFailedMessage: 'Verification failed. Please try again.',
        emailRequired: 'Email address is required',
        passwordRequired: 'Password is required',
        userNotAssociatedWithBuilding: 'User is not associated with any building',
        noPermissionsToAccess: 'You do not have permissions to access the system',
        trialExpiredAllBuildings: 'Trial period for all buildings has expired',
        emailLabel: 'Email',
        passwordLabel: 'Password',
        rememberMe: 'Remember me',
        loginButton: 'Login',
        registerNow: 'Register now',
        backToHomePage: 'Back to home page',
        
        // Registration
        fullNameLabel: 'Full Name',
        phoneLabel: 'Phone Number',
        cityLabel: 'City',
        addressLabel: 'Address',
        apartmentNumberLabel: 'Apartment Number',
        floorNumberLabel: 'Floor Number',
        confirmPasswordLabel: 'Confirm Password',
        enterCity: 'Enter city',
        enterStreet: 'Enter street',
        addNewCity: 'Add new city',
        addNewStreet: 'Add new street',
        noResultsFound: 'No results found',
        
        // Email Verification
        enterSixDigitCode: 'Please enter a 6-digit code',
        verificationCompleted: 'Verification completed successfully!',
        emailVerifiedSuccessfully: 'Email address verified successfully!',
        emailVerificationForPasswordReset: 'Email verification for password reset',
        verificationCode: 'Verification Code',
        verify: 'Verify',
        resendCode: 'Resend code',
        verifying: 'Verifying...',
        
        // Forgot Password
        resetCodeSent: 'Reset code has been sent to your email address',
        emailNotVerified: 'Email address has not been verified yet',
        
        // Landing Page
        trialExpiredMessage: 'Trial period has expired',
        welcomeMessage: 'Welcome',
        smartBuildingManagement: 'Smart building management system',
        keyFeatures: 'Key Features',
        
        // Building Management
        userNotLoggedIn: 'User not logged in',
        fillAllFields: 'Please fill all fields',
        invalidFloorsNumber: 'Invalid number of floors',
        buildingAddedSuccessfully: 'Building added successfully!',
        addNewBuilding: 'Add New Building',
        buildingDetails: 'Building Details',
        numberOfFloors: 'Number of Floors',
        numberOfApartments: 'Number of Apartments',
        houseNumber: 'House Number',
        street: 'Street',
        
        // Navigation
        navigationMenu: 'Navigation Menu',
        
        // Common Actions
        submit: 'Submit',
        sending: 'Sending...',
        update: 'Update',
        yes: 'Yes',
        no: 'No',
        tenant: 'Tenant',
        manager: 'Manager',
        committeeMembe: 'Committee Member',
        
        // Issues/Support
        openHelpTicket: 'Open Help Ticket',
        subjectOfInquiry: 'Subject of Inquiry',
        submitInquiry: 'Submit Inquiry',
        
        // Announcements
        announcements: 'Announcements',
        addAnnouncement: 'Add Announcement',
        
        // Billing
        loadingBillingData: 'Loading billing data...',
        buildingAccessBlocked: 'Building access is blocked',
        billingAndSubscriptionsManagement: 'Billing and Subscriptions Management',
        subscriptionStatus: 'Subscription Status',
        paymentHistory: 'Payment History',
        quickActions: 'Quick Actions',
        
        // Payment Methods
        creditCard: 'Credit Card',
        bankTransfer: 'Bank Transfer',
        cash: 'Cash',
        check: 'Check',
        noSubscriptionFound: 'No subscription found for this building',
        
        // Tasks
        task: 'Task',
        building: 'Building',
        description: 'Description',
        priority: 'Priority',
        currentStatus: 'Current Status',
        
        // Validation Messages
        fullNameRequired: 'Full name is required',
        phoneRequired: 'Phone number is required',
        invalidEmail: 'Invalid email address',
        passwordMinLength: 'Password must contain at least 6 characters',
        emailAlreadyExists: 'This email already exists in the system',
        
        // Cities (for fallback)
        telAviv: 'Tel Aviv',
        jerusalem: 'Jerusalem',
        haifa: 'Haifa',
        beerSheba: 'Beer Sheba',
        rishonLezion: 'Rishon LeZion',
        
        // Streets (for fallback)
        herzlStreet: 'Herzl',
        bialikStreet: 'Bialik',
        weizmannStreet: 'Weizmann',
        allenbyStreet: 'Allenby',
        benGurionStreet: 'Ben Gurion',
        
        // Additional Login texts
        loginFailed: 'Login failed. Please check your details and try again.',
        emailVerificationRequired: 'To log in, you need to verify your email address.',
        systemLogin: 'System Login',
        enterLoginDetails: 'Please enter your login details',
        forgotPassword: 'Forgot password?',
        rememberMeSubtext: '(Data will be saved even after closing the browser)',
        loggingIn: 'Logging in...',
        goToPayment: 'Go to Payment',
        registerNewAccount: 'Register now',
        backToMain: 'Back to main page',
        emailVerificationRequired2: 'Email verification required',
        connectingToSystem: 'Connecting to system...',
        trialExpiredMessageShort: 'Trial period has expired',
        choosePaymentPlan: 'You must choose a payment plan to continue using the system',
        emailNotAvailable: 'Email address is not available. Please try to register again.',
        newVerificationCodeSent: 'A new verification code has been sent to your email address. Please check your inbox.',
        errorSendingVerificationCode: 'Error sending verification code. Please try again.'
    }
};

// Helper function to get translation
export const getTranslation = (key, language = 'he', params = {}) => {
    let translation = translations[language]?.[key] || translations.he[key] || key;
    
    // Replace parameters like {days} with actual values
    Object.keys(params).forEach(param => {
        translation = translation.replace(`{${param}}`, params[param]);
    });
    
    return translation;
};

// Hook for easier usage
export const useTranslation = (language = 'he') => {
    const t = (key, params = {}) => getTranslation(key, language, params);
    return { t };
};